import SidebarCollapse from '@Web/Pages/Web/OurSoftware/Components/SidebarCollapse';
import Button from '@Web/Src/Components/Button';
import { router } from '@inertiajs/react';

function SidebarItem({
    currentPage,
    setCurrentPage,
    item,
    isOpen,
    onToggle,
    registerButton = false,
}) {
    const activeSidebarItem = currentPage.value === item.value;
    const { label } = item;

    const handleClick = () => {
        registerButton
            ? router.visit(route('customer.auth.register'))
            : router.visit(route('web.pages.demo'));
    };

    return (
        <SidebarCollapse
            title={
                <div
                    className={`hover:!text-light group relative flex h-max w-full cursor-pointer items-center justify-center gap-4 p-1 py-3`}
                >
                    <img
                        src={`/assets/images/webp/web/icons/${item.value}${activeSidebarItem ? '-active' : ''}.webp`}
                        alt={`${label}`}
                        className='size-12 size-9 min-w-9'
                    />
                    <h3
                        className={`text-center text-lg font-semibold ${
                            activeSidebarItem ? 'text-dark' : '!text-tertiary'
                        }`}
                    >
                        {label}
                    </h3>
                </div>
            }
            item={item}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            isOpen={isOpen}
            onToggle={onToggle}
        >
            <div className='medium:pb-4'>
                <div className='medium:mt-5 medium:flex hidden w-full flex-1 justify-center p-5'>
                    <img
                        className='h-auto max-h-[300px] w-full max-w-[280px]'
                        src={`/assets/images/webp/web/demo-section/${currentPage.value}.webp`}
                        alt={currentPage.label}
                    />
                </div>
                {item.text}
                <Button
                    className='!mt-10'
                    name={registerButton ? __('Start trial') : __('Get a demo')}
                    onClick={handleClick}
                />
            </div>
        </SidebarCollapse>
    );
}

export default SidebarItem;
